export enum InvoiceDbStatus {
    Initial = 1,
    Sent = 2,
    Payed = 3,
    UnpaidLost = 4
}
